import DashboardRoundedIcon from '@mui/icons-material/DashboardRounded'
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded'
import AccountBalanceWalletRoundedIcon from '@mui/icons-material/AccountBalanceWalletRounded'
import CasinoRoundedIcon from '@mui/icons-material/CasinoRounded'
import GppMaybeRoundedIcon from '@mui/icons-material/GppMaybeRounded'
import VerifiedUserRoundedIcon from '@mui/icons-material/VerifiedUserRounded'
import CardGiftcardRoundedIcon from '@mui/icons-material/CardGiftcardRounded'
import WorkspacePremiumRoundedIcon from '@mui/icons-material/WorkspacePremiumRounded'
import SupportAgentRoundedIcon from '@mui/icons-material/SupportAgentRounded'
import WebStoriesRoundedIcon from '@mui/icons-material/WebStoriesRounded'
import AssessmentRoundedIcon from '@mui/icons-material/AssessmentRounded'
import AdminPanelSettingsRoundedIcon from '@mui/icons-material/AdminPanelSettingsRounded'
import { navigationModel } from '../app/routeManifest'

/**
 * @typedef {{ label: string, to: string, badgeKey?: string }} NavLeaf
 * @typedef {{ title: string, icon?: import('@mui/material/SvgIcon').SvgIconComponent, items?: NavLeaf[], defaultOpen?: boolean }} NavSection
 * @type {NavSection[]}
 */
export const navigationSections = [
  ...navigationModel.map((section) => ({
    ...section,
    icon:
      section.title === 'Overview'
        ? DashboardRoundedIcon
        : section.title === 'Players'
          ? PeopleAltRoundedIcon
          : section.title === 'Wallet'
            ? AccountBalanceWalletRoundedIcon
            : section.title === 'Games'
              ? CasinoRoundedIcon
              : section.title === 'Fraud & security'
                ? GppMaybeRoundedIcon
                : section.title === 'KYC & compliance'
                  ? VerifiedUserRoundedIcon
                  : section.title === 'Promotions'
                    ? CardGiftcardRoundedIcon
                    : section.title === 'VIP & engagement'
                      ? WorkspacePremiumRoundedIcon
                      : section.title === 'Support'
                        ? SupportAgentRoundedIcon
                        : section.title === 'CMS'
                          ? WebStoriesRoundedIcon
                          : section.title === 'Reports'
                            ? AssessmentRoundedIcon
                            : section.title === 'Settings'
                              ? AdminPanelSettingsRoundedIcon
                              : undefined,
  })),
]
